<script setup>

	import {Link} from "@inertiajs/vue3";
	import { routingHelper } from '@/utility';
	import {scrollTop} from "@/utility";

</script>

<template>
	<ul class="pagination">

		<li v-if="current_page > 1">
			<Link :href="url(current_page - 1)" :onFinish="scrollTop" aria-label="Inapoi">
				<i class="lnr icon-chevron-left"></i>
			</Link>
		</li>

		<li v-for="button in buttons">
			<Link :href="url(button)" :class="{ 'current' : button == current_page}" :onFinish="scrollTop">{{button}}</Link>
		</li>

		<li v-if="current_page < last_page">
			<Link :href="url(current_page + 1)" :onFinish="scrollTop" aria-label="Inainte">
				<i class="lnr icon-chevron-right"></i>
			</Link>
		</li>

	</ul>
</template>

<script>

let max_buttons = 5;

export default {
	name: "Pagination",
	props : [
		'current_page',
		'total_pages',
		'last_page',
		'ignored_qs_parameters'
	],
	data(){
		return {}
	},
	mounted(){

	},
	computed : {

		buttons_count(){
			return max_buttons < this.last_page ? max_buttons : this.last_page;
		},

		buttons() {

			let buttons = [];

			// Insert current button
			buttons.push(this.current_page);

			// Set jump step to 1
			let jump = 1;

			// Insert fill buttons to the left and to the right until buttons.length reached desired value
			while (buttons.length < this.buttons_count) {

				// Insert to the left if bigger than zero
				if (this.current_page - jump > 0) {
					buttons.unshift(this.current_page - jump);
				}

				// Exit while loop if the button count is correct, after inserting the left fill button
				if (buttons.length == this.buttons_count)
					break;

				// Insert to the right if smaller than last page
				if (this.current_page + jump <= this.last_page)
					buttons.push(this.current_page + jump);

				// Increment jump
				jump++;

			}

			if (this.current_page > max_buttons){
				buttons.unshift('1...');
			}

			if (this.current_page < this.last_page - max_buttons + 1){
				buttons.push('...' + this.last_page);
			}

			return buttons;
		}

	},
	methods : {

		url(page){

			if(typeof window === 'undefined') return; // No window in nodejs

			if(page.toString().includes('...')){
				page = page.replace('...', '');
			}
			return routingHelper.getCurrentRoute().remove(this.ignored_qs_parameters).set('p', page).generate();

		}

	}

}
</script>

<style scoped>

</style>